import { Controller } from "@hotwired/stimulus"

export default class ReadRoomsController extends Controller {
  read() {
    setTimeout(() => {
      const roomId = Current.room.id
      const ele = $(".chat-list")[0]
      const controller = this.application.getControllerForElementAndIdentifier(ele, 'room-list')
      controller?.read(roomId)
    }, 500);
  }

  backToList() {
    const userList = document.getElementById("user-list");
    const chatArea = document.getElementById("chat-area");
    if (globalThis.innerWidth < 1399) {
      history.back()
      setTimeout(() => {
        userList.classList.remove("d-none");
        chatArea.classList.add("d-none");
        $('.room-user').removeClass('disabled-link active');
      }, 100);
    }
  }
}
